import { assert, Test } from "oc-e2e-testrunner";
import {
  assertSegmentIstLückenlosGefüllt,
  createStreckeWithMauerUndBreite,
  resetArrangement,
} from "./utils";
import {
  getSollZwischenabstandVerbose,
  getZwischenabstandAnSeiteVerbose,
  LINKS,
  RECHTS,
} from "../arrangement/elementFunctions";
import { v2 } from "oc-threejs/short3";

export default {
  name: "TestTorMaximalbreite1200",
};

export const test1200mmMauerLinksRechtsChangeElementToTorAnschlagLinks: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(1.204, { links: true, rechts: true });
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  const element = s.getElemente()[0];
  element.anschlagAuswahlwert = APP.richMetadata.findAuswahlwert("Anschlag_links");
  APP.arrangement.setSelectedObjects(element);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.update3d();
  const elementMeta = APP.richMetadata.findEnsureAnyObjekt(
    "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15"
  );
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(element, elementMeta, richtung)
  );
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );
  assert.deepEquals(
    soll,
    ist,
    "assert.deepEquals(soll,ist) failed: rot=getSollZwischenabstandVerbose, grün=getZwischenabstandAnSeiteVerbose"
  );
  assertSegmentIstLückenlosGefüllt(s);
};

export const test1200mmMauerLinksRechtsChangeElementToTorAnschlagRechts: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(1.204, { links: true, rechts: true });
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  const element = s.getElemente()[0];
  element.anschlagAuswahlwert = APP.richMetadata.findAuswahlwert("Anschlag_rechts");
  APP.arrangement.setSelectedObjects(element);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.update3d();
  const elementMeta = APP.richMetadata.findEnsureAnyObjekt(
    "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15"
  );
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(element, elementMeta, richtung)
  );
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );
  assert.deepEquals(
    soll,
    ist,
    "assert.deepEquals(soll,ist) failed: rot=getSollZwischenabstandVerbose, grün=getZwischenabstandAnSeiteVerbose"
  );
  assertSegmentIstLückenlosGefüllt(s);
};

export const test1200mmMauerLinksRechts: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(1.2, { links: true, rechts: true });
  const leerraum = s.empties[0];
  APP.arrangement.setSelectedObjects(leerraum);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.update3d();
  const elementMeta = APP.richMetadata.findEnsureAnyObjekt(
    "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15"
  );
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(leerraum, elementMeta, richtung)
  );
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  const element = s.getElemente()[0];
  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );
  assert.deepEquals(
    soll,
    ist,
    "assert.deepEquals(soll,ist) failed: rot=getSollZwischenabstandVerbose, grün=getZwischenabstandAnSeiteVerbose"
  );
  assertSegmentIstLückenlosGefüllt(s);
};

export const test1200mmSizeFestgelegt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  const leerraum = s.empties[0];
  APP.arrangement.setSelectedObjects(leerraum);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert, size: v2(1.2, 1.8) });
  agt.update3d();
  assert.equals(1.2, s.getElemente()[0].breite);
};

export const test1201mmMauerLinksRechts: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(1.21 + (1.21 - 1.17), {
    links: true,
    rechts: true,
  });
  APP.arrangement.setSelectedObjects(s.empties[0]);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  const tor = s.getElemente()[0];
  assert.equals(1, s.getElemente().length);
  assert.equals(1.2, tor.breite);
};

export const test1201mmMauerLinks: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(1.21 + (1.21 - 1.17), {
    links: true,
    rechts: false,
  });
  APP.arrangement.setSelectedObjects(s.empties[0]);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  const tor = s.getElemente()[0];
  assert.equals(1, s.getElemente().length);
  assert.equals(1.2, tor.breite);
};

export const test1201mmTorpfostenAufgeschraubt: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(3, { links: true });
  APP.arrangement.setSelectedObjects(s.empties[0]);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  s.getEmpties().forEach((e) => e.elementeAufruecken(true));
  agt.update3d();
  const tor = s.getElemente()[0];
  s.getPfosten().forEach(
    (p) =>
    (p.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
      "Aufgeschraubt auf festem Boden"
    ))
  );
  assert.equals(1, s.getElemente().length);
  assert.equals(0.98, tor.breite);
  tor.setKonfigurierbareBreite(1.21);
  agt.update3d();
  assert.equals(1, s.getElemente().length);
  assert.equals(1.2, tor.breite);
};

export const test1201mmOhneTorschließer: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  const leerraum = s.empties[0];
  agt.setSelectedObjects(leerraum);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert, size: v2(1.2, 1.8) });
  agt.selectedObjects[0].torschließerAuswahlwert =
    APP.richMetadata.findAuswahlwert("Torschließer_mit");
  agt.update3d();
  assert.equals(1.2, s.getElemente()[0].breite);
  agt.selectedObjects[0].setKonfigurierbareBreite(1.21);
  agt.update3d();
  assert.equals(1.21, s.getElemente()[0].breite);
  assert.equals(undefined, agt.selectedObjects[0].torschließerAuswahlwert);
};
